import { createStore } from 'vuex'

const translations =
{
  ES: {
    Heading: {
      HeadingH1: 'Explora los restaurantes',
      HeadingH2: 'de nuestros mundos'
    },
    World: 'Todos los mundos',
    Available: 'Sujeto a calendario de apertura',
    SeeMenu: 'Ver carta',
    SeeAllWorlds: 'Ver todos los mundos'
  },
  CA: {
    Heading: {
      HeadingH1: 'Explora els restaurants',
      HeadingH2: 'dels nostres mons'
    },
    World: 'Tots els mons',
    Available: 'Segons calendari d’obertura',
    SeeMenu: 'Veure carta',
    SeeAllWorlds: 'Veure tots els mons'
  },
  EN: {
    Heading: {
      HeadingH1: 'Explore the restaurants',
      HeadingH2: 'in our worlds'
    },
    World: 'All worlds',
    Available: 'Subject to opening calendar',
    SeeMenu: 'See menu',
    SeeAllWorlds: 'See all worlds'
  },
  FR: {
    Heading: {
      HeadingH1: 'Explorez les restaurants',
      HeadingH2: 'de nos mondes'
    },
    World: 'Tous les mondes',
    Available: 'Selon le calendrier d’ouverture',
    SeeMenu: 'Voir menu',
    SeeAllWorlds: 'Voir tous les mondes'
  }
}

const restaurants = [
  {
    world: 'Mediterrània',
    name: 'Vinosfera tapes i vins',
    description: {
      ES: 'Restaurante especializado en tapas y pinchos del Mediterráneo. Además, cuenta con una amplia carta de vinos.',
      CA: 'Restaurant especialitzat en tapes i pinxos del Mediterri. A més, compta amb una àmplia carta de vins.',
      EN: 'Restaurant specializing in Mediterranean tapas and pinchos. In addition, it has an extensive wine list.',
      FR: 'Restaurant spécialisé dans les tapas et brochettes de la Méditerranée. Il dispose également d’une vaste carte des vins.'
    },
    link: 'https://cartadigital.barmanagerapp.com/site/index/show/VINOSFERA/carte',
    image: 'vinosfera.jpg'
  },
  {
    world: 'Mediterrània',
    name: 'Racó de Mar',
    description: {
      ES: 'En la gran terraza Racó de Mar los comensales encontrarán un ambiente relajado y los mejores sabores del Mediterráneo.',
      CA: 'A la gran terrassa Racó de Mar els comensals trobaran un ambient relaxat i els millors sabors de la Mediterrània.',
      EN: 'On the large terrace Racó de Mar diners will find a relaxed atmosphere and the best flavors of the Mediterranean.',
      FR: 'Sur la grande terrasse Racó de Mar, les convives trouveront une atmosphère détendue et les meilleures saveurs de la Méditerranée.'
    },
    link: 'https://cartadigital.barmanagerapp.com/site/index/show/RacdelMar/carte',
    image: 'racodemar.jpg'
  },
  {
    world: 'Mediterrània',
    name: 'Café Saula',
    description: {
      ES: 'Ven a Café Saula a probar nuestros exquisitos pasteles y cafés. ¡También tenemos bocadillos y pizzas! Disponemos de oferta de bocadillos y snacks sin gluten.',
      CA: 'Vine a Cafè Saula a provar els nostres exquisits pastissos i cafès. També tenim entrepans i pizzes! Disposem d’una oferta d’entrepans i snacks sense gluten.',
      EN: 'Come to Café Saula to try our exquisite pastries and coffees. We also have snacks and pizzas! We have a gluten-free sandwich and snack offer.',
      FR: 'Venez au Café Saula pour déguster nos gâteaux et cafés exquis. Nous avons aussi des collations et des pizzas! Nous disposons d’une sélection de sandwichs et de snacks sans gluten'
    },
    link: 'https://horecatec.net/portaventura/pdf/cafe_saula.pdf',
    image: 'cafesaula.jpg'
  },
  {
    world: 'Mediterrània',
    name: 'Cercevería l\'Estació',
    description: {
      ES: 'Recupera fuerzas con los mejores bocadillos calientes de mediterranea',
      CA: 'Recupera forces amb els millors entrepans calents de mediterrània',
      EN: 'Regain strength with the best hot Mediterranean snacks',
      FR: 'Retrouvez des forces avec les meilleures collations chaudes de Mediterranea'
    },
    link: 'https://horecatec.net/portaventura/pdf/cerveceria_estacio.pdf',
    image: 'estacio.jpg'
  },
  {
    world: 'Polynesia',
    name: 'Bora Bora',
    description: {
      ES: 'Déjate llevar por tu lado salvaje y degusta exóticos platos de cocina internacional con toques tropicales (ensaladas, hamburguesas, pollo, etc.).',
      CA: 'Deixa\'t portar pel teu costat salvatge i degusta exòtics plats de cuina internacional amb tocs tropicals(amanides, hamburgueses, pollastre, etc.).',
      EN: 'Let yourself be carried away by your wild side and taste exotic dishes of international cuisine with tropical touches (salads, hamburgers, chicken, etc.).',
      FR: 'Laissez-vous emporter par votre côté sauvage et dégustez des plats exotiques de cuisine internationale aux touches tropicales (salades, hamburgers, poulet, etc.).'
    },
    link: 'https://horecatec.net/portaventura/pdf/bora_bora.pdf',
    image: 'borabora.jpg'
  },
  {
    world: 'SésamoAventura',
    name: 'La Cocina de Epi',
    description: {
      ES: 'Tenemos para ti pizzas, pasta, hamburguesas, pollo, ensaladas, postres y café en el área familiar más colorida de todo PortAventura World.',
      CA: 'Tenim per a tu pizzes, pasta, hamburgueses, pollastre, amanides, postres i cafè a l\'àrea familiar més acolorida de tot PortAventura World.',
      EN: 'We have for you pizzas, pasta, burgers, chicken, salads, desserts and coffee in the most colorful family area in all of PortAventura World.',
      FR: 'Nous avons pour vous des pizzas, des pâtes, des hamburgers, du poulet, des salades, des desserts et du café dans la zone familiale la plus colorée de PortAventura World.'
    },
    link: 'https://horecatec.net/portaventura/pdf/cocina_epi.pdf',
    image: 'sesamoaventura.jpg'
  },
  // {
  //   world: 'China',
  //   name: 'Sichuan',
  //   description: {
  //     ES: 'Solo en el restaurante Sichuan de PortAventura podrás degustar los mejores rollitos de primavera, ensaladas, arroces y muchos otros platos representativos de la gastronomía china.',
  //     CA: 'Només al restaurant Sichuan de PortAventura podràs degustar els millors rotllets de primavera, amanides, arrossos i molts altres plats representatius de la gastronomia xinesa.',
  //     EN: 'Only in the Sichuan restaurant of PortAventura you can taste the best spring rolls, salads, rice dishes and many other dishes representative of Chinese cuisine.',
  //     FR: 'Seul le restaurant Sichuan de PortAventura vous propose les meilleurs petits pains de printemps, salades, riz et autres plats représentatifs de la cuisine chinoise.'
  //   },
  //   link: 'https://cartadigital.barmanagerapp.com/site/index/show/LaHacienda2/carte',
  //   image: 'sichuan.jpg'
  // },
  // {
  //   world: 'China',
  //   name: 'Marco Polo',
  //   description: {
  //     ES: 'Buffet con especialidades de todo el mundo, con protagonismo de las especialidades asiaticas',
  //     CA: 'Buffet amb especialitats de tot el món, amb protagonisme de les especialitats asiàtiques',
  //     EN: 'Buffet with specialties from all over the world, with prominence of Asian specialties',
  //     FR: 'Buffet avec des spécialités du monde entier, avec une importance des spécialités asiatiques'
  //   },
  //   link: 'https://cartadigital.barmanagerapp.com/site/index/show/LaHacienda2',
  //   image: 'marcopolo.jpg'
  // },
  {
    world: 'China',
    name: 'Dagana',
    description: {
      ES: 'En Dagana podrás reponer fuerzas tras vivir la aventura de Shambhala, o armarte de valor antes de subirte a ella. Siéntate en su terraza y disfruta de sus hamburguesas y perritos calientes.',
      CA: 'En Dagana podràs reposar forces després de viure l\'aventura de Shambhala, o armar- te de valor abans de pujar- te a ella.Seu a la seva terrassa i gaudeix de les seves hamburgueses i frankfurts.',
      EN: 'In Dagana you can regain strength after living the adventure of Shambhala, or arm yourself with courage before getting on it. Sit on their terrace and enjoy their burgers and hot dogs.',
      FR: 'A Dagana, vous pourrez vous ressourcer après avoir vécu l’aventure de Shambhala, ou vous armer de courage avant d’y monter. Asseyez-vous sur sa terrasse et dégustez ses hamburgers et ses hot-dogs.'
    },
    link: 'https://horecatec.net/portaventura/pdf/dagana.pdf',
    image: 'dagana.jpg'
  },
  {
    world: 'China',
    name: 'Canton',
    description: {
      ES: 'Déjate seducir por los sabores de la gastronomía típica de China, con un wok show-cooking (fideos al gusto, brochetas, rollitos de primavera, etc.), mientras contemplas unas magníficas vistas a la plaza central.',
      CA: 'Deixa\'t seduir pels sabors de la gastronomia típica de la Xina, amb un show- cooking wok(fideus al gust, pinxos, rotllos de primavera, etc.), mentre contemples magnífiques vistes de la plaça central.',
      EN: 'Let yourself be seduced by the flavors of the typical gastronomy of China, with a wok show-cooking (noodles to taste, skewers, spring rolls, etc.), while contemplating magnificent views of the central square.',
      FR: 'Laissez-vous séduire par les saveurs de la cuisine typique de la Chine, avec un wok show-cooking (nouilles au goût, brochettes, rouleaux de printemps, etc.), tout en admirant une vue magnifique sur la place centrale.'
    },
    link: 'https://horecatec.net/portaventura/pdf/canton.pdf',
    image: 'canton.jpg'
  },
  // {
  //   world: 'México',
  //   name: 'Hacienda El Charro',
  //   description: {
  //     ES: 'Rodeado de las plantas y fuentes del patio poscolonial de La Hacienda El Charro, podrás elegir entre una exquisita variedad de platos tradicionales de la suculenta gastronomía mexicana.',
  //     CA: 'Envoltat de les plantes i fonts del pati postcolonial de la Hisenda El Charro, podràs triar entre una exquisida varietat de plats tradicionals de la suculenta gastronomia mexicana.',
  //     EN: 'Surrounded by the plants and fountains of the postcolonial courtyard of La Hacienda El Charro, you can choose from an exquisite variety of traditional dishes of the succulent Mexican cuisine.',
  //     FR: 'Entouré des plantes et des fontaines de la cour postcoloniale de La Hacienda El Charro, vous pourrez choisir parmi une variété exquise de plats traditionnels de la succulente cuisine mexicaine.'
  //   },
  //   link: 'https://cartadigital.barmanagerapp.com/site/index/show/LaHacienda2',
  //   image: 'haciendaelcharro.jpg'
  // },
  {
    world: 'México',
    name: 'La Cantina',
    description: {
      ES: 'Únete a la fiesta que los mariachis tienen preparada para ti en el restaurante La Cantina mientras saboreas unos ricos nachos con guacamole, un buen plato de chili con carne o la típica ensalada mexicana.',
      CA: 'Uneix-te a la festa que els mariachis tenen preparada per a tu al restaurant La Cantina mentre assaboreixes uns deliciosos nachos amb guacamole, un bon plat de xili amb carn o la típica amanida mexicana.',
      EN: 'Join the party that the mariachis have prepared for you at la Cantina restaurant while you savor some delicious nachos with guacamole, a good chili dish with meat or the typical Mexican salad.',
      FR: 'Joignez-vous à la fête que les mariachis ont préparée pour vous au restaurant La Cantina tout en dégustant de riches nachos au guacamole, un bon plat de chili à la viande ou la salade mexicaine typique.'
    },
    link: 'https://horecatec.net/portaventura/pdf/la_cantina.pdf',
    image: 'lacantina.jpg'
  },
  {
    world: 'México',
    name: 'Cactus express',
    description: {
      ES: 'Burritos, hot dog y nachos para reponer fuerzas',
      CA: 'Burritos, hot dog i nachos per reposar forces',
      EN: 'Burritos, hot dog and nachos to regain strength',
      FR: 'Burritos, hot-dog et nachos pour reconstituer les forces'
    },
    link: 'https://horecatec.net/portaventura/pdf/cactus_express.pdf',
    image: 'cactusexpress.jpg'
  },
  {
    world: 'México',
    name: 'Palma real',
    description: {
      ES: 'Hamburguesas y bocadillos',
      CA: 'Hamburgueses i entrepans',
      EN: 'Burgers and snacks',
      FR: 'Burgers et collations'
    },
    link: 'https://horecatec.net/portaventura/pdf/la_palma.pdf',
    image: 'palmareal.jpg'
  },
  {
    world: 'México',
    name: 'Taquería La Catrina',
    description: {
      ES: 'Wraps, tacos,nachos y mucho más.',
      CA: 'Wraps, tacos, nachos i molt més.',
      EN: 'Wraps, tacos, nachos and much more.',
      FR: 'Wraps, tacos, nachos et bien plus encore.'
    },
    link: 'https://horecatec.net/portaventura/pdf/la_catrina.pdf',
    image: 'taqueria.jpg'
  },
  {
    world: 'Far West',
    name: 'The Iron Horse',
    description: {
      ES: 'La mejor comida casera americana hecha por Madame Lilie te espera en el restaurante The Iron Horse. ¡Famoso en todo el Lejano Oeste!',
      CA: 'El millor menjar casolà americana fet per Madame Lilie t\'espera al restaurant The Iron Horse. ¡Famós a tot el Llunyà Oest!',
      EN: 'The best homemade American food made by Madame Lilie awaits you at The Iron Horse restaurant. Famous throughout the Wild West!',
      FR: 'La meilleure cuisine maison américaine faite par Madame Lilie vous attend au restaurant The Iron Horse. Célèbre dans tout le Far West!'
    },
    link: 'https://cartadigital.barmanagerapp.com/site/index/show/IRONHORSE3/carte',
    image: 'ironhorse.jpg'
  },
  {
    world: 'Far West',
    name: 'The Old Steak House',
    description: {
      ES: 'La mejor carne del poblado de Penitence se encuentra en el restaurante The Old Steak House. Carnívoros, ¡este es vuestro sitio!',
      CA: 'La millor carn de el poblat de Penitence es troba al restaurant The Old Steak House. Carnívors, aquest és el vostre lloc!',
      EN: 'The best meat in the village of Penitence is found in The Old Steak House restaurant. Carnivores, this is your place!',
      FR: 'La meilleure viande du village de Penitence se trouve au restaurant The Old Steak House. Carnivores, c’est votre place!'
    },
    link: 'https://horecatec.net/portaventura/pdf/the_old_steak_house.pdf',
    image: 'theoldsteak.jpg'
  },
  {
    world: 'Far West',
    name: 'Jeremias\' Food',
    description: {
      ES: 'Ensaladas, pasta y deliciosas pizzas recién hechas te esperan en la cocina del restaurante del viejo Jeremías.',
      CA: 'Amanides, pasta i delicioses pizzes acabades de fer t\'esperen a la cuina del restaurant de l\'vell Jeremies.',
      EN: 'Salads, pasta and delicious freshly made pizzas await you in the kitchen of old Jeremiah\'s restaurant.',
      FR: 'Salades, pâtes et délicieuses pizzas fraîchement préparées vous attendent dans la cuisine du restaurant du vieux Jérémie.'
    },
    link: 'https://horecatec.net/portaventura/pdf/jeremias.pdf',
    image: 'jeremias.jpg'
  }
]

export default createStore({
  state: {
    loading: true,
    codeLang: 'ES',
    codeLangs: [
      'ES',
      'CA',
      'EN',
      'FR'
    ],
    translations: null,
    worlds: [
      'All',
      'Mediterrània',
      'Polynesia',
      'SésamoAventura',
      'China',
      'México',
      'Far West'
    ],
    selectedWorld: 'All',
    restaurants: restaurants,
    filter: 'All'
  },
  mutations: {
    changLoading: function (state, value) {
      state.loading = value
    },
    changeLang (state, lang) {
      state.codeLang = lang
    },
    setTranslation (state, value) {
      state.translations = value
    },
    changeFilter (state, value) {
      state.filter = value
    },
    changeWorld (state, value) {
      state.selectedWorld = value
    }
  },
  actions: {
    async getChangeLanguages (context) {
      const translationsResult = translations[this.state.codeLang]
      context.commit('setTranslation', translationsResult)
    }
  },
  modules: {
  }
})
